
var picturegrids = document.getElementsByClassName('picturegrid__container');

for (var i = 0; i < picturegrids.length; i++) {
    picturegrids[i].querySelectorAll('.picturegrid__container--link').forEach(slide => {
        slide.addEventListener('mouseover', function () {
            this.classList.add('hovered');
        });

        slide.addEventListener('mouseout', function () {
            this.classList.remove('hovered');
        });
    });
}


// WEBPACK FOOTER //
// ./Components/Blocks/PictureGrid/picturegrid.js